<template>
  <div class="hideme">
  <v-layout
    text-xs-left
    wrap
  >
    <v-flex md4 xs12 order-md1 order-xs2>
      <v-card-text>
        <div  class="body-2 half-p mt-1"><p>Images & Videos</p></div>
        <v-container fluid grid-list-md class="pa-0">
        <v-layout wrap>

            <v-flex xs4 sm3 md6 lg4 xl3 v-for="(image, i) in images"
                   :key="'images-'+i"

            >
          <v-img
            :src="require('@/assets/'+image.source)"
            aspect-ratio="1"
            :class="{'thumbborder':1,'thumbtrans':fullimage!==undefined,'thumbthis':fullimage===i}"
            @click="fullimage = i"
            v-ripple
            style="cursor:pointer;"
          ></v-img>

            </v-flex>

          </v-layout>
        </v-container>

        <div  class="body-2 half-p mt-4"><p>Documents &  Resources</p></div>

        <div  class="body-2 half-p mt-4"><p>External Links</p></div>

      </v-card-text>
    </v-flex>
    <v-flex md8 xs12  order-md2 order-xs1>
    <v-card-text class="text-xs-justify" >
      <v-layout wrap>
        <v-flex xs12 order-md2 order-xs1 :class="{'mt-4': ($vuetify.breakpoint.name !== 'sm' && $vuetify.breakpoint.name !== 'xs')}">
      <div ><h3 class="headline mb-3">{{title}}</h3></div>
      <div  class="half-p body-2"><p>{{intro}}</p></div>
      <div  class="half-p" v-html="content"></div>
        </v-flex>

        <v-flex xs12  v-if="fullimage !== undefined" order-md1 order-xs2 style="border-radius: 3px; border: 1px solid lightgray; margin-top: 32px;">
<v-card class="elevation-0">
      <v-toolbar dense class="elevation-0 white nopadding">
        <v-toolbar-title class="subheading">{{images[fullimage].title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon flat @click="fullimage=undefined"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-responsive  :aspect-ratio="16/9" class="grey lighten-5 imagebackground" :style="{ 'background-image': 'url('+require('@/assets/'+images[fullimage].source)+')' }">
      </v-responsive>
  <v-card-text>
    <v-layout align-space-around justify-space-around column fill-height>
      <v-flex >
        <div class="body-1 caption mb-1 half-p" v-html="images[fullimage].description"></div>
        <v-layout align-end>
          <v-flex>
            <div class="caption font-weight-light ">Raw image: 1920x1080, 349 kb, JPEG</div>
            <div class="caption font-weight-light ">Image credits: {{ images[fullimage].credits }}</div>
          </v-flex>
          <v-flex class=" text-xs-right">
            <v-btn class="ml-0 mr-0 mt-0 mb-0" dark outline color="red darken-1" :href="require('@/assets/'+images[fullimage].source)" target="_blank">Download</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
    </v-flex>

  </v-layout>
  </div>
</template>

<script>

import JQuery from 'jquery'
let $ = JQuery

export default {
  components: {},
  props: {
    content: {
      type: String,
      required: false,
      default: '<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>'
    },
    title: {
      type: String,
      required: false,
      default: 'Unknown'
    },
    images: {
      type: Array,
      required: false,
      default: function () { return [] }
    },
    intro: {
      type: String,
      required: false,
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    page: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      fullimage: undefined
    }
  },
  watch: {

    'page': function () {
      this.fullimage = undefined
      // this.expand = null
      $('.hideme').fadeOut(0, function () {
        $('.hideme').fadeIn()
      })
    }
  }
}
</script>

<style>

  .nopadding .v-toolbar__content {
    padding: 0 0 0 12px;
  }

.half-p p {
  margin-bottom: 8px;
}
  .hidden {
    visibility: hidden;
  }
  .thumbtrans {
    opacity: .5;
  }

  .thumbthis {
    opacity: 1 !important;
    border-bottom-color: #e53935 !important;
    border-bottom-width: 3px !important;
    border-right-width: 0 !important;
    border-left-width: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

.thumbborder {
  border-radius: 3px; border: 1px solid lightgray;
  background-color: #e0e0e0;
}

  .imagebackground {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  }
</style>
